'use strict';

angular.module('TurneroApp').component('coAdmin', {
    bindings: {
        usuario: '<'
    },
    controller: [
        '$state',
        '$window',
        '$sessionStorage',
        '$localStorage',
        'TurneroAppConstant',
        '$interval',
        '$mdDialog',
        'seguridadService',
        'generalService',
        '$scope',
        '$timeout',
        function ($state, $window, $sessionStorage, $localStorage, TurneroAppConstant, $interval, $mdDialog, seguridadService, generalService, $scope, $timeout) {
            var ctrl = this;
            ctrl.sinConexion = false;
            ctrl.sinConexionTimer = null;
            ctrl.centroAtencionSeleccionado = {};
            ctrl.isOpen = $window.innerWidth > 1024;
            ctrl.timer = 0;

            ctrl.$onInit = function () {
                ctrl.tick = $interval(ctrl.calcTiempoLoading, 1000);
                ctrl.getVersion();
                ctrl.getServer();
            }

            ctrl.$onChanges = function () {
                swal.close();
                $mdDialog.destroy();

                seguridadService.getTokenCidi().then(function (token) {
                    // Primero intentar restaurar desde sessionStorage
                    if ($sessionStorage.TurneroApp_CentroSeleccionado) {
                        ctrl.cambiarCentroDeAtencion($sessionStorage.TurneroApp_CentroSeleccionado);
                    }
                    // Si no hay centro en sessionStorage, intentar desde localStorage (usado por el sidebar)
                    else if ($localStorage.centroAtencionSeleccionado && $localStorage.centroAtencionSeleccionado.id) {
                        ctrl.cambiarCentroDeAtencion($localStorage.centroAtencionSeleccionado);
                    }

                    if (!ctrl.centroAtencionSeleccionado.id) {
                        $state.go('admin');
                    }
                });
            };

            ctrl.$onDestroy = function () {
                //cuando el componente se destruye se cancela el interval
                if (ctrl.tick)
                    $interval.cancel(ctrl.tick);
            };

            ctrl.calcTiempoLoading = function () {
                if (ctrl.timer < 4) {
                    ctrl.timer += 1;
                } else {
                    $interval.cancel(ctrl.tick);
                }
            };

            ctrl.getServer = function () {

                generalService.Get_Server_Id().$promise.then(function (resultado) {
                    ctrl.server = resultado.Data;
                }).catch(function (error) {

                })
            }

            ctrl.getVersion = function () {
                generalService.Get_Version().$promise.then(function (resultado) {
                    if (resultado) {
                        ctrl.version = resultado.Version;
                        ctrl.entorno = resultado.Entorno;
                        TurneroAppConstant.vedi.url = resultado.VeDiUrl;
                        TurneroAppConstant.vedi.veDiIdAplicacion = resultado.VeDiIdAplicacion;
                        TurneroAppConstant.vedi.ciDiUrlRelacion = resultado.CiDiUrlRelacion;
                    }
                }) 
            }

            ctrl.cambiarCentroDeAtencion = function (centroAtencionSeleccionado) {
                ctrl.centroAtencionSeleccionado = centroAtencionSeleccionado;
                $sessionStorage.TurneroApp_CentroSeleccionado = centroAtencionSeleccionado;
            };
                        
            //cuando se llama a una conexión
            $scope.$on('BeforeHubConnectionStart', function (event, hub) {
                //si es la primera vez que se conecta o ya estaba conectado entonces doy por hecho que no se conectó hasta que reciba el AfterHubConnectionStart
                if (!ctrl.sinConexion) {
                    //le doy unos segundos antes de mostrar la alerta
                    if (!ctrl.sinConexionTimer)
                        ctrl.sinConexionTimer = $timeout(function () { ctrl.sinConexion = true }, 3000);
                }
            });

            //cuando se conecta al hub oculto el toast
            $scope.$on('AfterHubConnectionStart', function (event, hub) {
                if (ctrl.sinConexionTimer)
                    $timeout.cancel(ctrl.sinConexionTimer);

                ctrl.sinConexion = false;
            });

            //cuando se desconecta el hub muestro el toast
            $scope.$on('AfterHubConnectionClose', function (event, hub) {
                ctrl.sinConexion = true;
            });
        }],
    template: require('./admin.html')
});



// WEBPACK FOOTER //
// ./app/components/layout/admin/adminComponent.js